import { Injectable } from "@angular/core";
import { IKeyValueStore } from "./key-value-store.interface";

@Injectable()
export class LocalStorageStore implements IKeyValueStore {
  async get<T>(key: string): Promise<T | null> {
    const rawValue = localStorage.getItem(key);
    if (!rawValue) {
      return null;
    }

    try {
      return JSON.parse(rawValue) as T;
    } catch {
      return null;
    }
  }

  async set<T>(key: string, value: T): Promise<void> {
    localStorage.setItem(key, JSON.stringify(value));
  }

  async remove(key: string): Promise<void> {
    localStorage.removeItem(key);
  }

  async clear(): Promise<void> {
    localStorage.clear();
  }
}
